import { VendorBuyingAgreementRebateCategoryRebates } from '../../../components/Vendor';

export function BuyingAgreementRebateCategoryRebates() {
  return <VendorBuyingAgreementRebateCategoryRebates />;
}
